// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/renders/h1.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* #af8559; */
/* #d8b694; */
#root {
  margin: 0;
  font-family: "Josefin Sans", sans-serif;
  color: #d8b694;
}

footer{
  display: flex;
  justify-content: center;
}

footer img {
  width: 100px;
}

#whoami {
  margin-top: 5%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  padding-bottom: 85px;
}

.imgContainer {
  position: relative;
  overflow: hidden;
  width: 100%; 
  height: 100dvh;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-size: cover;
  background-color: rgba(0, 0, 0, 0.1); /* Fundo preto com 10% de opacidade */

}

.about-container{
  background-color: #efefef;
  width: 70%;
  border-radius: 5px;
  min-width: 375px;
  display: flex;
  justify-content: space-evenly;
}

.about-text{
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #695036;
}

.about-text p {
  font-size: calc(10px + 1vw);
}

.picture{
  width: 20%;
  margin: 15px;
}

.picture img {
  width: 285px;
}

body {
  background: #efefef;
  margin: 0
}

section {
  padding-top: 85px;
}

.main {
  background: #efefef;
  height: 100%;
  width: 100%;
  position: absolute;
  min-width: 410px;
  margin-top: 80px;
}

.personal {
  padding-top: 0;
  position: relative;
  /* margin: 0 auto 25dvh; */
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  min-height: 100%;
  animation: tracking-in-expand 2s cubic-bezier(0.215, 0.610, 0.355, 1.000) both;
  z-index: 1;
}

.name {
    font-size: calc(25px + 3vw);
    font-weight: 700;
    margin-top: 30vh;
    margin-bottom: 0;
    color: #af8559;
    font-family: "Allura", cursive;

}

.renders {  
  animation: fade-in 3s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  margin-top: -150px;
  padding-top: 0;
  position: relative;
  z-index: 2;
}

#contact {
  padding-top: 40px;
}

.contact-container{
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 20px;
  padding-bottom: 10px;
}

.icon-hover:hover{
  filter: invert(57%) sepia(72%) saturate(285%) hue-rotate(350deg) brightness(85%) contrast(79%);
}

.contact-content{
 min-width: 190px;
 min-height: 175px;
 display: flex;
 flex-direction: column;
 align-items: center;
 /* background-color: pink; */
 /* border: 1px  solid black */
  ;
  
}

.bugdet-container {
  display: flex;
  flex-direction: column;
  line-height: 2.3vh;
  align-items: center
}

@media (max-width: 1400px)
{
  .about-container {
    flex-direction: column;
    display: flex;
    align-items: center;
  }

  .picture {
    display: flex;
    justify-content: center;
    width: unset;
  }

  .picture img {
    width: 40%;
  }
  .about-text {
    width: 90%;
  }

  .about-text p {
    font-size: calc(13px + 1vw);
  }

}@keyframes fade-in{0%{opacity:0}100%{opacity:1}}
@keyframes tracking-in-expand {
  0% {
    letter-spacing: -0.5em;
    opacity: 0;
  }
  40% {
    opacity: 0.6;
  }
  100% {
    opacity: 1;
  }
}

@keyframes slide-in-left {
  0% {
    transform: translateX(-1000px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slide-in-bottom {
  0% {
    transform: translateY(1000px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

* {
  scrollbar-width: thin;
  scrollbar-color: #af8559 #efefef;
}

*::-webkit-scrollbar {
  width: 7px;
  width: 7px;
}
*::-webkit-scrollbar-track {
  border-radius: 1px;
  background-color: #efefef;
}

*::-webkit-scrollbar-track:hover {
  background-color: #d8b694;
}

*::-webkit-scrollbar-track:active {
  background-color: #d8b694;
}

*::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background-color: #af8559
}

*::-webkit-scrollbar-thumb:hover {
  background-color: #af8559
}

*::-webkit-scrollbar-thumb:active {
  background-color: #af8559
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,aAAa;AACb,aAAa;AACb;EACE,SAAS;EACT,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,yDAAsC;EACtC,4BAA4B;EAC5B,aAAa;EACb,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,yDAA8C;EAC9C,4BAA4B;EAC5B,sBAAsB;EACtB,oCAAoC,EAAE,qCAAqC;;AAE7E;;AAEA;EACE,yBAAyB;EACzB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAEhB,8EAA8E;EAC9E,UAAU;AACZ;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,8BAA8B;;AAElC;;AAEA;EAEE,mEAAmE;EACnE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,8FAA8F;AAChG;;AAEA;CACC,gBAAgB;CAChB,iBAAiB;CACjB,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,4BAA4B;CAC5B,6BAA6B;;;AAG9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB;AACF;;AAEA;;EAEE;IACE,sBAAsB;IACtB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;;EAEA;IACE,2BAA2B;EAC7B;;AAEF,CAGwD,mBAAmB,GAAG,SAAS,CAAC,KAAK,SAAS,CAAC;AAevG;EACE;IACE,sBAAsB;IACtB,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IAEU,8BAA8B;IACtC,UAAU;EACZ;EACA;IAEU,wBAAwB;IAChC,UAAU;EACZ;AACF;;AAEA;EACE;IAEU,6BAA6B;IACrC,UAAU;EACZ;EACA;IAEU,wBAAwB;IAChC,UAAU;EACZ;AACF;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF","sourcesContent":["/* #af8559; */\n/* #d8b694; */\n#root {\n  margin: 0;\n  font-family: \"Josefin Sans\", sans-serif;\n  color: #d8b694;\n}\n\nfooter{\n  display: flex;\n  justify-content: center;\n}\n\nfooter img {\n  width: 100px;\n}\n\n#whoami {\n  margin-top: 5%;\n  background-image: url(./assets/bg.png);\n  background-repeat: no-repeat;\n  display: flex;\n  justify-content: center;\n  padding-bottom: 85px;\n}\n\n.imgContainer {\n  position: relative;\n  overflow: hidden;\n  width: 100%; \n  height: 100dvh;\n  background-image: url(./assets/renders/h1.png);\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-color: rgba(0, 0, 0, 0.1); /* Fundo preto com 10% de opacidade */\n\n}\n\n.about-container{\n  background-color: #efefef;\n  width: 70%;\n  border-radius: 5px;\n  min-width: 375px;\n  display: flex;\n  justify-content: space-evenly;\n}\n\n.about-text{\n  width: 50%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  color: #695036;\n}\n\n.about-text p {\n  font-size: calc(10px + 1vw);\n}\n\n.picture{\n  width: 20%;\n  margin: 15px;\n}\n\n.picture img {\n  width: 285px;\n}\n\nbody {\n  background: #efefef;\n  margin: 0\n}\n\nsection {\n  padding-top: 85px;\n}\n\n.main {\n  background: #efefef;\n  height: 100%;\n  width: 100%;\n  position: absolute;\n  min-width: 410px;\n  margin-top: 80px;\n}\n\n.personal {\n  padding-top: 0;\n  position: relative;\n  /* margin: 0 auto 25dvh; */\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  min-height: 100%;\n  -webkit-animation: tracking-in-expand 2s cubic-bezier(0.215, 0.610, 0.355, 1.000) both;\n  animation: tracking-in-expand 2s cubic-bezier(0.215, 0.610, 0.355, 1.000) both;\n  z-index: 1;\n}\n\n.name {\n    font-size: calc(25px + 3vw);\n    font-weight: 700;\n    margin-top: 30vh;\n    margin-bottom: 0;\n    color: #af8559;\n    font-family: \"Allura\", cursive;\n\n}\n\n.renders {\n  -webkit-animation: fade-in 3s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;  \n  animation: fade-in 3s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;\n  margin-top: -150px;\n  padding-top: 0;\n  position: relative;\n  z-index: 2;\n}\n\n#contact {\n  padding-top: 40px;\n}\n\n.contact-container{\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 20px;\n  padding-bottom: 10px;\n}\n\n.icon-hover:hover{\n  filter: invert(57%) sepia(72%) saturate(285%) hue-rotate(350deg) brightness(85%) contrast(79%);\n}\n\n.contact-content{\n min-width: 190px;\n min-height: 175px;\n display: flex;\n flex-direction: column;\n align-items: center;\n /* background-color: pink; */\n /* border: 1px  solid black */\n  ;\n  \n}\n\n.bugdet-container {\n  display: flex;\n  flex-direction: column;\n  line-height: 2.3vh;\n  align-items: center\n}\n\n@media (max-width: 1400px)\n{\n  .about-container {\n    flex-direction: column;\n    display: flex;\n    align-items: center;\n  }\n\n  .picture {\n    display: flex;\n    justify-content: center;\n    width: unset;\n  }\n\n  .picture img {\n    width: 40%;\n  }\n  .about-text {\n    width: 90%;\n  }\n\n  .about-text p {\n    font-size: calc(13px + 1vw);\n  }\n\n}\n\n\n@-webkit-keyframes fade-in{0%{opacity:0}100%{opacity:1}}@keyframes fade-in{0%{opacity:0}100%{opacity:1}}\n\n\n@-webkit-keyframes tracking-in-expand {\n  0% {\n    letter-spacing: -0.5em;\n    opacity: 0;\n  }\n  40% {\n    opacity: 0.6;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@keyframes tracking-in-expand {\n  0% {\n    letter-spacing: -0.5em;\n    opacity: 0;\n  }\n  40% {\n    opacity: 0.6;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes slide-in-left {\n  0% {\n    -webkit-transform: translateX(-1000px);\n            transform: translateX(-1000px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateX(0);\n            transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n@keyframes slide-in-bottom {\n  0% {\n    -webkit-transform: translateY(1000px);\n            transform: translateY(1000px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translateY(0);\n            transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n* {\n  scrollbar-width: thin;\n  scrollbar-color: #af8559 #efefef;\n}\n\n*::-webkit-scrollbar {\n  width: 7px;\n  width: 7px;\n}\n*::-webkit-scrollbar-track {\n  border-radius: 1px;\n  background-color: #efefef;\n}\n\n*::-webkit-scrollbar-track:hover {\n  background-color: #d8b694;\n}\n\n*::-webkit-scrollbar-track:active {\n  background-color: #d8b694;\n}\n\n*::-webkit-scrollbar-thumb {\n  border-radius: 5px;\n  background-color: #af8559\n}\n\n*::-webkit-scrollbar-thumb:hover {\n  background-color: #af8559\n}\n\n*::-webkit-scrollbar-thumb:active {\n  background-color: #af8559\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
